<template>
  <div>
    <h4>Condizioni</h4>
    <input type="hidden" name="price[appliable_set]" v-model="currentAppliableSetJson" />
    <ul>
      <li v-for="(attrValue, attrName, index) in currentAppliableSet" :key="attrName" class="price-conditions">
        <div class="row-actions">
          <a @click="remove" :attribute="attrName"><i class="fa-light fa-trash pulsante_comando small delete"></i></a>
        </div>
        <div class="row-connector">
          <p v-if="index > 0">{{ i18nJS.and }}</p>
        </div>
        <div class="row-data control mychzn-obbligatorio">
          {{ i18nJS.prices.edit.condition_pre }}
          <span class="badge badge-notice">{{ i18nJS.prices.attributes[attrName] }}</span>
          {{ i18nJS.prices.edit.condition_post }}:
          <v-select2
            v-model="currentAppliableSet[attrName]"
            :options-list="valueLabels[attrName]"
            :multiple="true"
            :data-allow-clear="false"
            :data-minimumInputLength="1"
            :class="'full-width'"
          >
          </v-select2>
        </div>
      </li>
      <li v-if="canAddMore" class="price-conditions">
        <div class="row-actions">
          <a @click="add" v-if="allNewConditionFieldsFilled"><i class="fa-light fa-floppy-disk pulsante_comando small"></i></a>
          <a @click="clearNewCondition" v-if="allNewConditionFieldsFilled"><i class="fa-light fa-trash pulsante_comando small"></i></a>
          <a v-if="!allNewConditionFieldsFilled"><i class="fa-light fa-floppy-disk pulsante_comando small desaturate"></i></a>
        </div>
        <div class="row-connector">
          <p v-if="Object.keys(currentAppliableSet).length > 0">{{ i18nJS.and }}</p>
        </div>
        <div class="row-data control mychzn-obbligatorio">
          {{ i18nJS.prices.edit.condition_pre }}
          <span v-if="newCondition.cod == null">
            <v-select2
              v-if="newCondition.cod == null"
              v-model="newCondition['cod']"
              :options-list="availableAttributes"
              :multiple="false"
              :data-allow-clear="false"
              :data-minimumInputLength="1"
            >
            </v-select2>
          </span>
          <span v-if="newCondition.cod != null" class="badge badge-notice">
            {{ i18nJS.prices.attributes[newCondition.cod] }}
            <a @click="clearNewCondition">&nbsp;<i class="fa-light fa-xmark"></i></a>
          </span>
          <span class="new-attr-values" v-if="!!newCondition.cod">
            {{ i18nJS.prices.edit.condition_post }}
            <v-select2
              v-if="newCondition != {}"
              v-model="newCondition['values']"
              :options-list="valueLabels[newCondition.cod]"
              :multiple="true"
              :data-allow-clear="false"
              :data-minimumInputLength="1"
              :class="'full-width'"
            >
            </v-select2>
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import vSelect2 from './vSelect2';
export default {
  name: 'priceConditions',
  components: {
    vSelect2,
  },
  props: ['initialAppliableSet', 'optionsList', 'valueLabels'],
  computed: {
    allNewConditionFieldsFilled() {
      return !!this.newCondition.cod && this.newCondition.values && this.newCondition.values.length > 0;
    },
    availableAttributes() {
      return this.optionsList.filter((ary) => !Object.keys(this.currentAppliableSet).includes(ary[1]));
    },
    canAddMore() {
      return this.availableAttributes.length > 1;
    },
    currentAppliableSetJson() {
      return JSON.stringify(this.currentAppliableSet);
    },
    i18nJS() {
      return window.i18nJS;
    },
    moreThanOne() {
      return Object.keys(this.currentAppliableSet).length > 1;
    },
    newConditionAttrSelected() {
      return !!this.newCondition.cod;
    },
  },
  data() {
    return {
      attributes: [],
      currentAppliableSet: {},
      newCondition: { cod: null, values: [] },
    };
  },
  methods: {
    add(evt) {
      this.currentAppliableSet[this.newCondition.cod] = this.newCondition.values;
      this.currentAppliableSet = { ...this.currentAppliableSet };

      this.clearNewCondition();
    },
    clearNewCondition() {
      this.newCondition = { cod: null, values: [] };
    },
    remove(evt) {
      const attribute = evt.currentTarget.getAttribute('attribute');
      delete this.currentAppliableSet[attribute];
      this.currentAppliableSet = { ...this.currentAppliableSet };
    },
    isSelected(key, attribute) {
      const attrs = this.currentAppliableSet[attribute];
      return !!attrs && attrs.toString().split(',').includes(key);
    },
    labelFor(attrName, value) {
      return this.valueLabels[attrName][value];
    },
  },
  mounted() {
    this.currentAppliableSet = { ...this.initialAppliableSet };
    for (const key of Object.keys(this.initialAppliableSet)) {
      if (key) {
        const values = this.initialAppliableSet[key];
        let valuesAry = [];
        for (let value of values) {
          valuesAry = valuesAry.concat({
            value,
            label: this.labelFor(key, value),
          });
        }
        this.attributes = this.attributes.concat({
          name: key,
          label: i18nJS.prices.attributes[key],
          values: valuesAry,
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
li.price-conditions {
  border-bottom: 1px solid lightgrey;
  display: flex;
  list-style-type: none;

  & > .row-connector {
    margin: auto 0.2em;
    padding-bottom: 0.2em;
    width: 1em;

    & > p {
      font-size: 1.2em;
      margin: 0;
    }
  }

  & > .row-actions {
    margin: 0.4em 1em 0.4em 0;
  }

  & > .row-data {
    line-height: 3.3em;
  }
}
.full-width {
  width: 85%;
}
</style>
